export const SET_STUDENTS_DATA = "SET_STUDENTS_DATA";
export const GET_STUDENTS_DATA = "GET_STUDENTS_DATA";
export const SET_STUDENTS_LIST_DATA = "SET_STUDENTS_LIST_DATA";
export const SET_POST_DATA = "SET_POST_DATA";

export const SET_USER = "SET_USER";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ON_ERROR = "ON_ERROR";